export const AT_A_GLANCE_INPUT_LIMITS = {
	TITLE_LIMIT: 500,
	ENTITY_SUMMARY_LIMIT: 500,
	ENTITY_STATUS_LIMIT: 200,
	PRODUCT_LIMIT: 100,
	RESOURCE_TYPE_LIMIT: 100,
} as const;

export const bound = (value: string | undefined, limit: number): string | undefined => {
	const normalized = value?.trim();
	return normalized ? normalized.slice(0, limit) : undefined;
};

export const toIsoInstant = (value: string | null | undefined): string | undefined => {
	if (typeof value !== 'string') {
		return undefined;
	}

	const normalized = value.trim();
	if (!normalized || !/(?:Z|[+-]\d{2}:\d{2})$/i.test(normalized)) {
		return undefined;
	}

	const timestamp = new Date(normalized);
	return Number.isNaN(timestamp.getTime()) ? undefined : timestamp.toISOString();
};
